import { maybeSlugToUuid } from '#pplx/frontend/apps/ask/permalink-slug/permalinkSlug.js';
// Whether a sidebar link and the pathname point at the same thread. Legacy
// slug links remain supported so an already-open route still selects its row.
export function threadLinkMatchesPath(link, pathname) {
    if (link === pathname) {
        return true;
    }
    const linkUuid = threadLinkUuid(link);
    return linkUuid !== null && linkUuid === threadLinkUuid(pathname);
}
function threadLinkUuid(path) {
    return maybeSlugToUuid(path.split('/').pop() ?? '');
}
//# sourceMappingURL=threadLinkMatchesPath.js.map